export default "__VITE_ASSET__BRLWFZ$q__"